// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"442e686c","171":"adf925ed","374":"00998fd3","466":"f68a2a55","507":"03878be5","801":"73e39645","903":"659f575b"}[chunkId] + ".chunk.js";
};